import React from 'react';
import { Table, TableBody, TableCell, TableRow, Paper } from '@mui/material';

interface ConfigTableProps {
  config: any;
}

const renderValue = (value: any) => {
  if (Array.isArray(value)) {
    return (
      <Table size="small">
        <TableBody>
          {value.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="left">{renderValue(item)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  } else if (typeof value === 'object' && value !== null) {
    return (
      <Table size="small">
        <TableBody>
          {Object.entries(value).map(([key, val]) => (
            <TableRow key={key}>
              <TableCell align="left" width={"300px"}><strong>{key}</strong></TableCell>
              <TableCell align="left">{renderValue(val)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  } else {
    return value !== null && value !== undefined ? value.toString() : '';
  }
};

const ConfigTable: React.FC<ConfigTableProps> = ({ config }) => {
  if (!config) return null;

  const entries = Object.entries(config);

  return (
    <Paper elevation={3} style={{ padding: '16px', marginTop: '16px' }}>
      <Table>
        <TableBody>
          {entries.map(([key, value]) => (
            <TableRow key={key}>
              <TableCell align="left">{key}</TableCell>
              <TableCell align="left">{renderValue(value)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ConfigTable;
